import React, { useState } from 'react';
import { Block } from '../classes/Block';
import './BlockCreationPopup.css';

interface BlockCreationPopupProps {
  isOpen: boolean;
  onClose: () => void;
  onCreateEmpty: () => void;
  onCloneBlock: (sourceBlock: Block) => void;
  existingBlocks: Block[];
}

const BlockCreationPopup: React.FC<BlockCreationPopupProps> = ({
  isOpen,
  onClose,
  onCreateEmpty,
  onCloneBlock,
  existingBlocks
}) => {
  const [selectedOption, setSelectedOption] = useState<'empty' | 'clone'>('empty');
  const [selectedBlockIndex, setSelectedBlockIndex] = useState<number>(0);

  if (!isOpen) return null;

  const handleCreate = () => {
    if (selectedOption === 'empty') {
      onCreateEmpty();
    } else if (selectedOption === 'clone' && existingBlocks.length > 0) {
      const sourceBlock = existingBlocks[selectedBlockIndex];
      onCloneBlock(sourceBlock);
    }
    onClose();
  };

  const handleCancel = () => {
    setSelectedOption('empty');
    setSelectedBlockIndex(0);
    onClose();
  };

  return (
    <div className="block-creation-overlay" onClick={handleCancel}>
      <div className="block-creation-popup" onClick={(e) => e.stopPropagation()}>
        <h3>Create New Block</h3>
        
        <div className="creation-options">
          <label className="option-label">
            <input
              type="radio"
              name="creationType"
              value="empty"
              checked={selectedOption === 'empty'}
              onChange={(e) => setSelectedOption(e.target.value as 'empty' | 'clone')}
            />
            <span className="option-text">Empty Block</span>
          </label>
          
          <label className="option-label">
            <input
              type="radio"
              name="creationType"
              value="clone"
              checked={selectedOption === 'clone'}
              onChange={(e) => setSelectedOption(e.target.value as 'empty' | 'clone')}
              disabled={existingBlocks.length === 0}
            />
            <span className="option-text">Clone from Existing</span>
          </label>
        </div>

        {selectedOption === 'clone' && existingBlocks.length > 0 && (
          <div className="block-selection">
            <label htmlFor="blockSelect">Select block to clone:</label>
            <select
              id="blockSelect"
              value={selectedBlockIndex}
              onChange={(e) => setSelectedBlockIndex(Number(e.target.value))}
              className="block-select"
            >
              {existingBlocks.map((block, index) => (
                <option key={index} value={index}>
                  {block.name}
                </option>
              ))}
            </select>
          </div>
        )}

        <div className="popup-actions">
          <button
            type="button"
            onClick={handleCancel}
            className="cancel-btn"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={handleCreate}
            className="create-btn"
            disabled={selectedOption === 'clone' && existingBlocks.length === 0}
          >
            Create
          </button>
        </div>
      </div>
    </div>
  );
};

export default BlockCreationPopup; 